module.exports = __webpack_public_path__ + "static/media/4d-result-icon-white.f5f571b3.svg";